export default __webpack_public_path__ + "static/media/module-tender-hammer-color.087a0dec.svg";